module.exports = __webpack_public_path__ + "img/02_Icono.be700220.png";